import React from 'react'

import Modal from 'react-modal'

import {
  func, string, number, bool,
} from 'prop-types'

import ContactSupportBanner from './Components/ContactSupportBanner'
import PromoteModelHeader from './Components/PromoteModelHeader/PromoteModelHeader'
import PromoteModelSelectedModelSection from
  './Components/PromoteModelSelectedModelSection/PromoteModelSelectedModelSection'
import PromoteModelSidebar from './Components/PromoteModelSidebar/PromoteModelSidebar'
import PromoteModelTagsSection from './Components/PromoteModelTagsSection/PromoteModelTagsSection'
import PromoteModelWarningBanner from './Components/PromoteModelWarningBanner/PromoteModelWarningBanner'
import usePromoteModel from './Hooks/usePromoteModel'

function PromoteModel({
  closeModal,
  onStartCampaign,
  itemTitle,
  itemId,
  itemImage,
  itemPrice,
  itemSales,
  salesBoostPoints,
  limitTagCampaignsAndCostInflation = false,
  isReadOnly = false,
  promotionStatus = '',
  submittingCampaign = false,
}) {
  const {
    selectedTags,
    duration,
    contentPolicyAgreed,
    tags,
    tagsLoading,
    validationErrors,
    onModalClose,
    onTagSelect,
    onLevelSelect,
    getLevelCheckboxState,
    onAllTagsSelect,
    getAllTagsCheckboxState,
    onDurationChange,
    calculateTotalCost,
    canStartCampaign,
    onStartCampaignClick,
    toggleContentPolicyAgreement,
  } = usePromoteModel({
    itemId,
    closeModal,
    onStartCampaign,
    salesBoostPoints,
    limitTagCampaignsAndCostInflation,
    isReadOnly,
    submittingCampaign,
  })

  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={onModalClose}
      contentLabel="Promote Model Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--promote',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="promote-modal">
        <PromoteModelHeader onModalClose={onModalClose} isReadOnly={isReadOnly} />
        <div className="promote-modal__content">
          <div className="promote-modal__main">
            <ContactSupportBanner />
            {!isReadOnly && <PromoteModelWarningBanner />}
            <PromoteModelSelectedModelSection
              itemTitle={itemTitle}
              itemSales={itemSales}
              itemPrice={itemPrice}
              itemImage={itemImage}
            />
            <PromoteModelTagsSection
              tags={tags}
              tagsLoading={tagsLoading}
              selectedTags={selectedTags}
              onTagSelect={onTagSelect}
              onLevelSelect={onLevelSelect}
              onAllTagsSelect={onAllTagsSelect}
              getLevelCheckboxState={getLevelCheckboxState}
              getAllTagsCheckboxState={getAllTagsCheckboxState}
              limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
              isReadOnly={isReadOnly}
            />
          </div>
          <div className="promote-modal__divider" />
          <PromoteModelSidebar
            tagsLoading={tagsLoading}
            selectedTags={selectedTags}
            duration={duration}
            onDurationChange={onDurationChange}
            calculateTotalCost={calculateTotalCost}
            canStartCampaign={canStartCampaign}
            onStartCampaignClick={onStartCampaignClick}
            salesBoostPoints={salesBoostPoints}
            validationErrors={validationErrors}
            contentPolicyAgreed={contentPolicyAgreed}
            toggleContentPolicyAgreement={toggleContentPolicyAgreement}
            limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
            isReadOnly={isReadOnly}
            promotionStatus={promotionStatus}
            submittingCampaign={submittingCampaign}
          />
        </div>
      </div>
    </Modal>
  )
}

PromoteModel.propTypes = {
  closeModal: func.isRequired,
  onStartCampaign: func.isRequired,
  itemTitle: string.isRequired,
  itemId: number.isRequired,
  itemImage: string.isRequired,
  itemPrice: number.isRequired,
  itemSales: number.isRequired,
  salesBoostPoints: number.isRequired,
  limitTagCampaignsAndCostInflation: bool,
  isReadOnly: bool,
  promotionStatus: string,
  submittingCampaign: bool,
}

export default PromoteModel
